import { render, staticRenderFns } from "./Vimeo.vue?vue&type=template&id=3f25f43e&scoped=true"
import script from "./Vimeo.vue?vue&type=script&lang=js"
export * from "./Vimeo.vue?vue&type=script&lang=js"
import style0 from "./Vimeo.vue?vue&type=style&index=0&id=3f25f43e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f25f43e",
  null
  
)

export default component.exports